export const BLOGS_API_URL = "https://admin.vilengineering.com/api/public/blogs";

const normalizeBlog = (blog, index = 0) => {
    const category =
        typeof blog.category === "string"
            ? { name: blog.category, slug: blog.category }
            : blog.category || {};

    return {
        id: blog.id || blog.slug || `blog-${index}`,
        title: blog.title || blog.metaTitle || "VIL Engineering Blog",
        slug: blog.slug || blog.id || `blog-${index}`,
        excerpt:
            blog.excerpt ||
            blog.metaDescription ||
            "Read the latest fire safety insight from VIL Engineering.",
        content: blog.content || blog.excerpt || blog.metaDescription || "",
        image:
            blog.featuredImage ||
            blog.imageUrl ||
            blog.image ||
            blog.thumbnailUrl ||
            "",
        categoryName: category.name || "Fire Safety",
        categorySlug: category.slug || category.name || "fire-safety",
        publishedAt: blog.publishedAt || blog.updatedAt || "",
        updatedAt: blog.updatedAt || "",
        url: blog.url || "",
    };
};

export const normalizeBlogsResponse = (payload) => {
    const rawBlogs = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.blogs)
            ? payload.blogs
            : Array.isArray(payload?.data)
                ? payload.data
                : [];

    return rawBlogs
        .map((blog, index) => normalizeBlog(blog, index))
        .sort((a, b) => {
            const bDate = b.publishedAt ? new Date(b.publishedAt).getTime() : 0;
            const aDate = a.publishedAt ? new Date(a.publishedAt).getTime() : 0;
            return bDate - aDate || a.title.localeCompare(b.title);
        });
};

export const normalizeBlogCategories = (payload, blogs = []) => {
    const rawCategories = Array.isArray(payload?.categories) ? payload.categories : [];
    const names = rawCategories
        .map((category) =>
            typeof category === "string" ? category : category?.name
        )
        .filter(Boolean);

    return Array.from(
        new Set(["All", ...names, ...blogs.map((blog) => blog.categoryName).filter(Boolean)])
    );
};

export const fetchPublicBlogs = async (signal) => {
    const response = await fetch(BLOGS_API_URL, {
        headers: { Accept: "application/json" },
        signal,
    });

    if (!response.ok) {
        throw new Error(`Blogs request failed with ${response.status}`);
    }

    const payload = await response.json();
    const blogs = normalizeBlogsResponse(payload);

    return {
        blogs,
        categories: normalizeBlogCategories(payload, blogs),
    };
};

export const fetchPublicBlog = async (slug, signal) => {
    const response = await fetch(`${BLOGS_API_URL}/${encodeURIComponent(slug)}`, {
        headers: { Accept: "application/json" },
        signal,
    });

    if (!response.ok) {
        throw new Error(`Blog request failed with ${response.status}`);
    }

    const payload = await response.json();
    const blog = payload?.blog || payload?.data || payload;

    return normalizeBlog(blog);
};

export const formatBlogDate = (value) => {
    if (!value) return "";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";

    return new Intl.DateTimeFormat("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    }).format(date);
};
